/* eslint-disable react/purity */
/* eslint-disable no-throw-literal */
/**
 * Development-only: throw errors from the catalog so you can manually verify ErrorBoundary copy.
 *
 * Preview "We could not load part of the app" + Reload button (npm run dev only):
 *   http://localhost:3000/?previewChunkError=1
 *   http://localhost:3000/inbox?previewChunkError=1
 *
 * Or use ?eb=<key> on any URL inside an ErrorBoundary:
 *
 * Keys:
 *   timeout          — LazyLoadTimeoutError + timed out message
 *   chunk-fetch      — Failed to fetch dynamically imported module ("We could not load part of the app")
 *   module-script    — Importing a module script failed
 *   css-preload      — Unable to preload CSS
 *   css-chunk        — Loading CSS chunk … failed
 *   chunk-load       — ChunkLoadError in message
 *   aborted          — ERR_ABORTED
 *   fallback         — unknown runtime error (catalog fallback)
 *   string           — throw plain string (hardcoded fallback in boundary)
 *   nullish          — throw null (hardcoded fallback)
 *
 * Remove the query param and reload to recover.
 */

/**
 * @param {URLSearchParams} searchParams
 * @returns {string | null}
 */
function resolveDevErrorScenario(searchParams) {
  if (searchParams.has('previewChunkError')) {
    return 'chunk-fetch'
  }
  return searchParams.get('eb')
}

export default function ErrorBoundaryDevTrigger() {
  if (!import.meta.env.DEV) {
    return null
  }

  const scenario = resolveDevErrorScenario(new URLSearchParams(window.location.search))
  if (!scenario) {
    return null
  }

  switch (scenario) {
    case 'timeout': {
      const err = new Error('timed out while loading DevTrigger')
      err.name = 'LazyLoadTimeoutError'
      throw err
    }
    case 'chunk-fetch':
      throw new Error('Failed to fetch dynamically imported module')
    case 'module-script':
      throw new Error('Importing a module script failed')
    case 'css-preload':
      throw new Error('Unable to preload CSS')
    case 'css-chunk':
      throw new Error('Loading CSS chunk 123 failed')
    case 'chunk-load':
      throw new Error('ChunkLoadError: loading chunk failed')
    case 'aborted':
      throw new Error('Request failed with ERR_ABORTED')
    case 'fallback':
      throw new Error('DevTrigger: unknown runtime error')
    case 'string':
      throw 'DevTrigger plain string error'
    case 'nullish':
      throw null
    default:
      console.warn(
        `[ErrorBoundaryDevTrigger] Unknown eb=${JSON.stringify(scenario)}. ` +
          'See ErrorBoundaryDevTrigger.jsx for valid keys.',
      )
      return null
  }
}
